<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Service.view.Header') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('Service.view.Title') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ $t(mydata.title) }}</p>
                    </div>
                </div>
                <div class="p-field p-grid p-align-start">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('Service.view.Desc') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-html="mydata.content" id="desc"></p>
                    </div>
                </div>

                <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                    <router-link @mouseenter="editnotice($route.params.update_key)" :to="'/ServiceTerms/EditServiceTerms/' + $route.params.update_key">
                        <Button :label="$t('notice1.view.Edit')" class="p-button1 p-button-outlined p-button p-mr-2 p-mb-2" iconPos="left" icon="pi pi-pencil" id="Edit"> </Button>
                    </router-link>
                    <!-- <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"> </Button> -->
                </div><br><br>
                <!-- <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"> </Button>
                </div> -->
                <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                    <Button :label="$t('notice1.view.Back')" iconPos="left" icon="pi pi-replay" class="p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;margin-top: -26px"></Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ServiceTerms from '../../service/API/ServiceTerms';
// import {useRouter} from 'vue-router'
import moment from 'moment';
export default {
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {
                title: '',
                content: '',
            },
            id:'',
            update_key:''
        };
    },
    created() {
        this.serviceTerms = new ServiceTerms();
    },
    methods: {
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: 'Confirmation',
                message: 'Are you sure you want to delete?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    axios({ method: 'Post', url: `api/v1/admin/notice/delete`, data:{notice_id : id} }).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'NoticeList' });
                    });

                    this.$toast.add({ severity: 'info', summary: 'Deleted', detail: 'Deleted successfully', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
        editnotice(update_key) {
            this.serviceTerms.viewService(update_key).then((result) => {
                localStorage.setItem('desc', JSON.stringify(result[0]));
                // alert(res.result)
                // console.log(result[0].description)
            });
        },
    },
    mounted() {
        this.serviceTerms.viewService(this.$route.params.update_key).then((result) => {
            this.mydata.title = result[0].title;
            this.mydata.content = result[0].content;
            localStorage.setItem('desc', result[0].content);
            console.log(result);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}
/* .card.p-fluid {
    height: 100vh;
} */
.p-d-flex.p-jc-end.p-ai-center.dual-btn {
    margin-top: 13px;
}
button.p-button.p-component.p-button1.p-button-outlined.p-button-help.p-mr-2.p-mb-2 {
    background: black;
    color: white;
}
button.p-button.p-component.p-button-outlined.p-button-sm.p-mr-2.p-mb-2 {
    background: white;
    color: black;
    border: 1px solid;
}
#Edit{
    background: black;
    color: white;
}
</style>
